import React, { Fragment, useMemo } from 'react';
import { parseBroadcastBodyToSegments } from '../utils/broadcastLinkMarkup';

interface BroadcastMessageBodyProps {
  text: string;
  className?: string;
  linkClassName?: string;
  onLinkClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const BroadcastMessageBody: React.FC<BroadcastMessageBodyProps> = ({
  text,
  className,
  linkClassName,
  onLinkClick,
}) => {
  const segments = useMemo(() => parseBroadcastBodyToSegments(text), [text]);
  return (
    <span className={className}>
      {segments.map((seg, i) =>
        seg.type === 'text' ? (
          <Fragment key={i}>{seg.text}</Fragment>
        ) : (
          <a
            key={i}
            href={seg.href}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClassName}
            onClick={onLinkClick}
          >
            {seg.label}
          </a>
        ),
      )}
    </span>
  );
};

export default BroadcastMessageBody;
